import { DocumentListSection } from "../../../../../components/Proposal&Contracts/DocumentListSection.tsx"

export const defaultClientResponsibilities = [
  "Provide site access and utilities (power, water)",
  "Confirm all design and finish selections by specified deadline",
  "Maintain insurance coverage on the property",
  "Approve any change orders in writing prior to execution"
]

export function ContractClientResponsibilitiesSection() {
  return (
    <DocumentListSection
      title="Client Responsibilities"
      name="client_responsibilities"
      itemPlaceholder="Client responsibility"
      addButtonText="Responsibility"
    />
  )
}
